export default __webpack_public_path__ + "static/media/logo.52ab9ed5.svg";